<template>
  <div class="wrap">
    <div v-if="!DisplayKCB">
      <h3 class="title">我的课程</h3>
      <div class="course-categories">
        <span class="course-type" v-for="item in courseCategories" :key="item.id" :class="item.id === curType ? 'active' : ''" @click="changeCourseType(item.id)">{{ item.text }}</span>
      </div>
      <ul class="course-content" v-if="curType!=3">
        <li class="course-item" v-for="item in list" :key="item.id">
          <div v-if="item.pakeage == 1" class="biaoshi_kcb">课程包</div>
          <div class="course-img">
            <img :src="item.cover" alt="" />
            <p class="course-class">{{ item.period }}</p>
          </div>
          <div class="course-desc">
            <h4 class="course-title">{{ item.name }}</h4>
            <div class="course-time" v-if="item.start_time">
              上课时间
              <span>{{ item.start_time.substring(0, 16) }}</span>
            </div>
            <div class="course-time-block" v-else></div>
          </div>
          <div class="study-state">
            <div class="study-time not-begin" v-if="!Number(item.endNum)">未开始学习</div>
            <div class="complete-study study-time" v-else></div>
            <div class="start-study" @click="handleStartStudy(item, item.pakeage)">开始学习</div>
          </div>
        </li>
      </ul>
      <ul class="course-content" v-else>
        <li class="course-item" v-for="item in lists" :key="item.id" @click="tostudy(item)">
          <div class="course-img">
            <img :src="item.img" alt="" />
            <p class="course-class">{{ item.period }}</p>
          </div>
          <div class="course-desc">
            <el-tooltip  v-if="item.name.length>10" class="item" effect="dark" :content="item.name" placement="top-start">
            <h4 class="course-title">{{ item.name }}</h4>
            </el-tooltip>
            <h4 v-else class="course-title">{{ item.name }}</h4>
          </div>
          <div  class="progressbx">
            <p style="    font-size: 14px;">上次观看到 {{ transformation(item.view_time) }}</p>
            <el-progress :percentage="item.percent"></el-progress>
          </div>

        </li>
      </ul>
      <div class="pagination">
        <el-pagination background  :current-page="pagination.page" @current-change="handleCurrentChange" :page-size="6" layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </div>
    </div>
    <div v-else>
      <CoursePackageCourse @fanhuisy="fanhuisy" :cateId="Coursevalue" :Isitthehomepage="3" />
    </div>
  </div>
</template>

<script>
  import CoursePackageCourse from './CoursePackageCourse'
export default {
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      curType:0,
      courseCategories: Object.freeze([
        { id: 0, text: '全部课程' },
        { id: 1, text: '免费课程' },
        { id: 2, text: '付费课程' },
        { id: 3, text: '历史观看' },
      ]),
      list: [],
      lists: [],
      DisplayKCB: false,
      Coursevalue: {}
    }
  },
  components: {
    CoursePackageCourse
  },
  created() {
    if(this.$route.query.subTab === '4') {
      this.curType = 3
      this.historyinit()
    } else {
      this.getCourseList()
    }
  },
  methods: {
    fanhuisy() {
      this.DisplayKCB = false
      this.Coursevalue = {}
    },
    tostudy(val){
      console.log(val);
      this.$router.push({ path: `/yueke3/${val.course_id}/${val.class_id}`,query:{
        view_time:val.view_time,video_id:val.video_id,chapter_id:val.chapter_id,sectionId:val.sectionId,name:val.name,duration:val.duration,file_id:val.file_id
      }})
    },
    async getCourseList() {
      const data = {
        page: this.pagination.page,
        num: this.pagination.num,
        type: this.curType,
      }
      const res = await this.$axios.post('/stu/course/myCourses', data)
      if (res.data.status === 'success') {
        const listObj = res.data.data
        this.list = listObj.list
        this.pagination.total = listObj.count
      }
    },
    transformation(duration) {
      let g = duration;
      let m = parseInt((duration / 60) % 60);
      let s = duration % 60;
      if (s <= 9) {
        s = "0" + s;
      }
      if (m <= 9) {
        m = "0" + m;
      }
      if (g >= 3600) {
        g = g / 3600;
        g = parseInt(g);
        g = "0" + g + ":";
      } else {
        g = "";
      }
      return g + m + ":" + s;
    },
    changeCourseType(idx) {
      console.log(idx,'idx');
      this.curType = idx
      this.pagination.page = 1
      if (idx==3) {
        this.historyinit()
        return
      }
      this.getCourseList()
    },
    async historyinit(){
        const data = {
            page:this.pagination.page,
            page_num:6
        }
        const res = await this.$axios.post('/user/video/history',data)
        this.lists = res.data.data.data
        this.pagination.total = res.data.data.count
        // this.pageSize = (res.data.data.count>10?Math.ceil(res.data.data.count/10):1)
        console.log(res.data.data.count,'this.pageSize');
        // this.lista = [...this.lista, ...res.data.data.list]
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      if (this.curType==3) {
        this.historyinit()
        return
      }
      this.getCourseList()
    },
    // 跳转到课程详情
    handleStartStudy(val, index) {
      // this.$router.push({ path: `/yueke3?setid=${val.course_id}&class_id=${val.class_id}` })
      if (index == 0) {
        this.$router.push({ path: `/yueke3/${val.course_id}/${val.class_id}` })
      } else {
        this.DisplayKCB = true
        this.Coursevalue = val
      }
    },
  },
}
</script>

<style scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
.biaoshi_kcb {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 60px;
  height: 28px;
  opacity: 0.7;
  background: #000000;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  color: #ffffff;
  z-index: 100;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.wrap ::-webkit-scrollbar {
    display: none;
  }
.title {
  font-size: 20px;
  color: #202020;
  padding-bottom: 17px;
  border-bottom: 1px solid #e8eaec;
}
.course-categories {
  margin: 20px 0;
}
.course-type {
  width: 84px;
  height: 34px;
  display: inline-block;
  line-height: 34px;
  color: #202020;
  font-size: 14px;
  text-align: center;
  border-radius: 17px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.5s;
}
.active {
  background: #1872ED;
  color: #ffffff;
}
.course-content {
  /* width: 940px; */
  display: flex;
  flex-wrap: wrap;
}
.course-item {
  position: relative;
  border-radius: 4px;
  border: #e8eaec 1px solid;
  width: 29%;
  min-width: 190px;
  height: 312px;
  margin: 0 20px 20px 0;
}

.course-img {
  position: relative;
  width: 100%;
  min-height: 125px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
@media screen and (min-width: 1280px) {
  .course-img {
    height: 186px;
  }
}
@media screen and (max-width: 1280px) {
  .course-item {
    height: 260px;
  }
  .course-img {
    height: 125px;
  }
}

.course-img img {
  width: 100%;
  transition: all 0.5s;
}
.course-img img:hover {
  transform: scale(1.2);
}
.course-class {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  height: 36px;
  line-height: 36px;
  color: #ffffff;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}
.course-desc {
  padding: 0 10px;
  margin-bottom: 10px;
  position: relative;
}
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  color: #20242f;
  margin-bottom: 9px;
}
.course-time {
  font-size: 14px;
  color: #808695;
}
.course-time-block {
  height: 18px;
}
.course-time .course-time span {
  margin-right: 10px;
}
.study-state {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}
.study-state div {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 16px;
  font-size: 14px;
}
.study-state .study-time {
  text-align: left;
}
.complete-study {
  color: #808695;
}
.not-begin {
  color: #ff9c18;
}
.studying {
  color: #10a675;
}
.start-study {
  border: 1px solid #1872ed;
  color: #1872ed;
  cursor: pointer;
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ED;
}
.progressbx{
  padding: 10px;
  margin-top: 30px;
}
.course-title2{
 display: none;
 width: 100%;
 position: absolute;
 top: 32px;
 z-index: 99;
 left: 0;
 background: #fff;
}
.course-desc:hover .course-title2{
 display: block;
}
</style>
